import { useState, useEffect } from 'react';
import { doc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import moment from 'moment';

export const LastMonthlyBalance2 = (props) => {
  const user = props.user.userSession;

  const [monthlyBalance, setMonthlyBalance] = useState('0h 00min');

  useEffect(() => {
    (async () => {
      try {
        const calendarId = user.calendario[new Date().getFullYear()].id;
        let calendar = await getDoc(doc(db, 'calendars', calendarId));

        if (!calendar.exists()) return;

        calendar = calendar.data().data[moment().subtract(1, 'months').format('MMMM')];

        let theoretical = calendar.total.split(':')[0] * 60 + calendar.total.split(':')[1] * 1;
        let real = 0;

        //Obtengo los registros del mes anterior
        const records = await getDoc(doc(db, 'users', user.uid, 'registros', moment().subtract(1, 'months').format('MMMM-YYYY'))).then((doc) => Object.entries(doc.data()));

        //Calcula el total de horas teoricas imputadas por el usuario
        for (var i = 0; i < records.length; i++) {
          var dayRecords = records[i][1];
          if (dayRecords[0]?.status === 'Pendiente') continue;
          var longDayRecords = Object.entries(dayRecords).length - 1;
          var dailyTotal;
          if (Object.entries(dayRecords)[longDayRecords][1].totalAcumulado !== undefined || longDayRecords === 0) {
            dailyTotal = Object.entries(dayRecords)[longDayRecords][1].totalAcumulado;
          } else {
            dailyTotal = Object.entries(dayRecords)[longDayRecords - 1][1].totalAcumulado;
          }

          if (dailyTotal) {
            var dato = dailyTotal.split(':');
            real = real + dato[0] * 60 + dato[1] * 1;
          }
        }

        //Añade al teorico las horas de vacaciones solicitadas y aprobadas
        await getDocs(query(collection(db, 'users', user.uid, 'ausencias'), where('status', '==', 'Aceptado'))).then((doc) => {
          doc.forEach((document) => {
            //si hay registros de vacaciones en este mes
            //prettier-ignore
            if (moment(document.data().startDate, 'DD/MM/YYYY').format('MM/YYYY') === moment().subtract(1, 'months').format('MM/YYYY') || moment(document.data().endDate, 'DD/MM/YYYY').format('MM/YYYY') === moment().subtract(1, 'months').format('MM/YYYY')){
              let start = moment(document.data().startDate, 'DD/MM/YYYY');
              let end = moment(document.data().endDate, 'DD/MM/YYYY');

              //console.log('start', start.format('YYYY/MM/DD'));
              //console.log('end', end.format('YYYY/MM/DD'));

              //Detectar si hay cambio de mes en el periodo de vacaciones
              if (start.format('MM') !== end.format('MM')) {
                if (start.format('MM') === moment().format('MM')) {
                  end = moment(start).endOf('month');
                } else {
                  start = moment(end).startOf('month');
                }
              }

              //si solo hay un dia de vacaciones
              if (start.format('YYYY/MM/DD') === end.format('YYYY/MM/DD')) {
                real = real + parseInt(calendar.days.find((day) => day.date === start.format('YYYY-MM-DD')).hours.split(':')[0]) * 60;
                real = real + parseInt(calendar.days.find((day) => day.date === start.format('YYYY-MM-DD')).hours.split(':')[1]);
              } else {
                for (var m = start; m.isBefore(end + 1); m.add(1, 'days')) {
                  real = real + parseInt(calendar.days.find((day) => day.date === m.format('YYYY-MM-DD')).hours.split(':')[0]) * 60;
                  real = real + parseInt(calendar.days.find((day) => day.date === m.format('YYYY-MM-DD')).hours.split(':')[1]);
                }
              }
              
            }
          });
        });

        setMonthlyBalance(
          real - theoretical >= 0
            ? '+ ' + moment.utc((real - theoretical) * 60 * 1000).format('H[h] mm[min]')
            : '- ' + moment.utc((theoretical - real) * 60 * 1000).format('H[h] mm[min]')
        );
      } catch (error) {
        console.log('Error al calcular el balance mensual' + error);
      }
    })();
  }, []);

  return (
    <div className='mb-0 '>
      <span>
        Último mes <span className='text-dark fw-bold'> {monthlyBalance} </span>
      </span>
    </div>
  );
};
